import { render, staticRenderFns } from "./LabWindsorEquilibrium.vue?vue&type=template&id=22e0edf0&"
import script from "./LabWindsorEquilibrium.vue?vue&type=script&lang=ts&"
export * from "./LabWindsorEquilibrium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports